import {ACTION_CODE} from './_actionCode';
import {DealTagsService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'UPDATE_DEALTAG';

export async function updateDealTag(
    userData: Record<string, any>,
    dealTagId: number,
    payloadUpdate: Record<string, any>
) {
    try {
        LoggerService.logInfo('Action - updateDealTagById - Start');

        const updateDealTagByIdResult =
            await DealTagsService.updateDealTag(userData, dealTagId, payloadUpdate);

        LoggerService.logInfo('Action - updateDealTagById - End - Success');

        return ResultModel.newSuccessResult(updateDealTagByIdResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - updateDealTagById - End - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Erreur de mise à jour d\'une banque',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
